import { useStorage } from '@vueuse/core'

export function useConsentSelections() {
  const consent = useStorage<string | null>('consent-selections', null)

  function allowedAdvertising() {
    return consent.value?.includes('advertising')
  }

  function allowedAnalytics() {
    return consent.value?.includes('analytics')
  }

  return {
    allowedAdvertising,
    allowedAnalytics,
    consent
  }
}
